var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHouseKeepingDirtyNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.892 19.83a1.248 1.248 0 11-1.764 1.764 1.248 1.248 0 011.764-1.764zm-4.807 1.065a.624.624 0 11-.882.882.624.624 0 01.882-.882zM13.87 8.94l.187.126c1.762 1.259 2.226 3.658 1.056 5.46-1.086 1.673-4.31 6.045-6.166 6.187 0 0-1.208-.435-1.638-.642.385-1.304.862-2.446 1.226-2.81a31.272 31.272 0 01-2.864 1.863 85.192 85.192 0 002.007-3.192c-.444.445-1.806 1.568-3.334 2.218a8.003 8.003 0 01-1.113-1.18c.375-.406.858-.95 1.493-1.7-.287.287-1.124.5-2.158.616-.502-.748-.562-2.363-.567-2.515v-.012l.53-.116c2.59-.563 5.352-3.057 6.26-3.877a4.241 4.241 0 015.081-.426zM15.58 18.4a.624.624 0 11-.882.882.624.624 0 01.882-.882zm5.834-2.814a2 2 0 11-2.828 2.828 2 2 0 012.828-2.828zM19.677 2A2.326 2.326 0 0122 4.323c0 .628-.252 1.223-.697 1.659l-.139.125-4.718 3.933a5.267 5.267 0 00-1.664-1.99 4.954 4.954 0 00-.619-.375l-.216-.105 3.946-4.734A2.317 2.317 0 0119.677 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHouseKeepingDirtyNoFill);
export default __webpack_public_path__ + "static/media/ic_house_keeping_dirty_no_fill.0e928113c03b80518bea96edde7977c8.svg";
export { ForwardRef as ReactComponent };